import axios from '@/api/axios';
import i18n from '@/api/i18n/i18n';
import { openToast, TOAST_TYPE } from '@/utils/open-toast';

function getSettings(link, data = {}) {
  return axios.post(link, data).then((response) => {
    if (response.data.success) {
      return response;
    }

    openToast(response.data.message, TOAST_TYPE.ERROR);
    response.data = null;

    return response;
  });
}

export function getSecurityRules(id, type, ruleType) {
  return getSettings(`/security/secRules/?id=${id}&type=${type}&ruleType=${ruleType}`);
}

export function deleteRule(id) {
  return axios.post(`/security/deleteRule/?id=${id}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.recordSuccessfullyDeleted'), TOAST_TYPE.SUCCESS);
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function deleteCategory(id, profile, type) {
  return axios.post(`/security/deleteCategory/?id=${id}&profile=${profile}&type=${type}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.ruleGroupSuccessfullyDeleted'), TOAST_TYPE.SUCCESS);
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function editRule(id, name, dang, comment, caption, type) {
  return axios.post('/security/editRule', { id, name, dang, comment, caption, type }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.changesSuccessfullySaved'), TOAST_TYPE.SUCCESS);
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function editCategory(id, name) {
  return axios.post('/security/editCategory', { id, name }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.changesSuccessfullySaved'), TOAST_TYPE.SUCCESS);
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function addCategory(name, type) {
  return axios.post('/security/addCategory', { name, type }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.groupSuccessfullyAdded'), TOAST_TYPE.SUCCESS);
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function linkCategory(id, categoryId) {
  return axios.post(`/security/linkCategory/?id=${id}&categoryId=${categoryId}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.changesSuccessfullySaved'), TOAST_TYPE.SUCCESS);
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function addRule(name, dang, type, comment, caption, actType) {
  return axios.post('/security/addRule', { name, dang, type, comment, caption, actType }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.ruleSuccessfullyAdded'), TOAST_TYPE.SUCCESS);
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}
export function addGroupAppRule(profileId, ruleType, ruleId, direction) {
  return axios.post('/security/addGroupAppRule', { profileId, ruleType, ruleId, direction }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.ruleSuccessfullyAdded'), TOAST_TYPE.SUCCESS);
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function getAppsList(type) {
  return getSettings(`/security/appsList/?type=${type}`);
}

export function getRelations(id, dateFrom, dateTo) {
  return getSettings(`/security/relations/?id=${id}&dateFrom=${dateFrom}&dateTo=${dateTo}`);
}
export function getExtRelations(email, dateFrom, dateTo) {
  return getSettings(`/security/ext-relations/?email=${email}&dateFrom=${dateFrom}&dateTo=${dateTo}`);
}

export const getContacts = async () => {
  const { data } = await axios.get('/security/contacts');
  if (data.success) return data.result;
  openToast(data.message, TOAST_TYPE.ERROR);
  return null;
};

export function getWatermark(formData) {
  return getSettings('/security/watermark', formData);
}
